<div class="navigation-container">
  <div class="navigation">
    <div class="navigation-back-section text-white">
      <button
        class="navigation-back-section__button btn-unstyled d-flex align-items-center"
        #backBtn
        (click)="backToPreviousPage(backBtn)"
        [class.disabled-input]="history?.length === 1"
      >
        <ng-icon
          name="matArrowBackOutline"
          class="me-2"
        ></ng-icon>
        {{ 'Back' | translate }}
      </button>
    </div>
    <div
      class="navigation__navbar d-flex d-lg-block justify-content-between pt-2"
    >
      <div class="nav-container navbar-nav flex-grow-1">
        <div
          class="navigation__search"
          [class.flex-grow-1]="isShowSearchBar"
        >
          <div
            class="d-flex align-items-center justify-content-md-start flex-shrink-0"
          >
            @if (activeInnovationSpaceLogoDisplayed) {
              <button
                appUnsavedFormCheck
                class="nav-link d-flex flex-column justify-content-lg-start align-items-center ps-0 pointer-cursor nav-link-separator-after pe-3 btn-unstyled"
                (click)="onHomeIconClick()"
              >
                <span class="nav-item__icon-container position-relative pt-1">
                  <app-internal-icon
                    [name]="'home'"
                    [height]="24"
                  >
                  </app-internal-icon>
                </span>

                <span
                  [style.min-width.px]="'unset'"
                  class="font-size-sm"
                >
                  Home
                </span>
              </button>

              <span class="selected-org-logo d-flex col-1 mx-3 pointer-cursor">
                <button
                  class="btn-unstyled"
                  (click)="navigateToActiveInnovationSpaceDetail(selectedOrg)"
                  appUnsavedFormCheck
                >
                  <img
                    [src]="selectedOrg?.imgUrl ?? selectedOrg?.logo?.url"
                    [alt]="selectedOrg?.logo?.alt"
                    appDefaultPlaceholder
                    appDynamicImgUrl
                  />
                </button>
              </span>
            } @else {
              <div
                class="tenant-logo d-flex align-items-center logo-fix-size pointer-cursor pe-3"
              >
                <button
                  class="w-100 btn-unstyled"
                  (click)="navigateToActiveInnovationSpaceDetail()"
                  appUnsavedFormCheck
                >
                  <img
                    alt="tenant-logo"
                    [src]="tenantLogo"
                    appDefaultPlaceholder
                    appDynamicImgUrl
                  />
                </button>
              </div>
            }
          </div>
          @if (!isShowSearchBar) {
            <a
              class="nav-link d-none d-md-flex flex-md-column justify-content-lg-start align-items-center pointer-cursor"
              (click)="toggleSearchBar()"
            >
              <span
                class="nav-item__icon-container position-relative pt-1 d-flex align-items-center"
                style="height: 24px"
              >
                <ng-icon
                  name="matSearchOutline"
                  class="nav__item-icon"
                ></ng-icon>
              </span>
              <span
                [style.min-width.px]="'unset'"
                class="font-size-sm"
                translate
              >
                Search
              </span></a
            >
          }

          @if (isShowSearchBar) {
            <div class="nav-global-filter__search w-100 ms-3 me-4">
              <div
                class="search-control d-flex align-items-center justify-content-center"
              >
                <button
                  class="btn-unstyled d-flex align-items-center"
                  (click)="onSearch()"
                >
                  <ng-icon
                    name="matSearchOutline"
                    class="pointer-cursor"
                  ></ng-icon>
                </button>
              </div>
              <form
                action="#"
                class="global-filter__search-form"
              >
                <input
                  [attr.aria-label]="'Search' | translate"
                  #searchInput
                  type="text"
                  name="query"
                  class="form-control global-filter__search-input"
                  placeholder="{{ 'Search' | translate }}"
                  [(ngModel)]="searchText"
                  (ngModelChange)="onSearchTextChange($event)"
                  (keydown.enter)="onSearch()"
                />
              </form>
              <div class="search-control d-flex align-items-center">
                @if (sessionService.isOnSearchResultPage) {
                  <button
                    class="btn btn-link font-size-sm clear-all-btn me-3"
                    (click)="onClearText()"
                  >
                    Clear
                  </button>
                }

                <button
                  class="btn-unstyled me-3 d-flex align-items-center"
                  (click)="toggleSearchBar()"
                >
                  <ng-icon
                    name="matCloseOutline"
                    class="reset-search"
                    focusable="false"
                  ></ng-icon>
                </button>
              </div>
            </div>
          }
        </div>
        <div
          class="navigation__navs"
          [ngClass]="{
            show: isNavsActivated,
            'flex-shrink-0': isShowSearchBar,
          }"
        >
          <div class="navigation__nav d-flex flex-column flex-md-row">
            <div class="d-md-none text-end pe-3">
              <button
                class="btn-unstyled"
                (click)="toggleNavs()"
              >
                <ng-icon
                  name="matCloseOutline"
                  size="2rem"
                ></ng-icon>
              </button>
            </div>

            @if (navs) {
              <ul class="navbar-nav p-lg-0">
                @if (!isShowSearchBar) {
                  @for (nav of navs; track nav.name) {
                    <li
                      class="nav-item"
                      [ngClass]="{ 'dropdown dropdown-hover': nav.subMenus }"
                    >
                      <app-nav-item [item]="nav"></app-nav-item>
                    </li>
                  }
                  @if (navDropdownItems.length > 0) {
                    <div
                      ngbDropdown
                      class="nav-item nav-dropdown dropdown dropdown-hover"
                    >
                      <a
                        class="nav-link flex-md-column justify-content-lg-start align-items-center pointer-cursor d-none d-md-flex"
                        [class.route-active]="shouldActiveMore()"
                      >
                        <ng-icon
                          name="matMenuOutline"
                          class="nav__item-icon"
                        ></ng-icon>

                        <span
                          [style.min-width.px]="'unset'"
                          class="py-1 font-size-sm"
                          translate
                        >
                          More
                          <ng-icon
                            name="matArrowDropDownOutline"
                            class="ms-1 font-size-sm"
                          ></ng-icon
                        ></span>
                      </a>
                      <ul
                        ngbDropdownMenu
                        class="nav-dropdown-items p-3"
                      >
                        @for (nav of navDropdownItems; track nav.name) {
                          <li class="nav-item p-0">
                            <app-nav-item-dropdown
                              [item]="nav"
                              [wrapperClass]="'nav-item-dropdown'"
                            ></app-nav-item-dropdown>
                          </li>
                        }
                      </ul>
                    </div>
                  }
                }

                <li
                  class="nav-item nav-link-separator-before d-flex align-items-center py-2"
                  [class]="
                    communitySpacesDropdownDisplayed
                      ? 'd-none d-md-block'
                      : 'd-none'
                  "
                >
                  <app-community-space-dropdown />
                </li>

                @if (sessionService.authenticated || mobileHeader) {
                  <li
                    class="nav-item d-flex align-items-center"
                    [class.nav-link-separator-before]="
                      !communitySpacesDropdownDisplayed
                    "
                  >
                    <app-nav-news-messages
                      class="flex-grow-1"
                    ></app-nav-news-messages>
                  </li>

                  <li
                    class="nav-item dropdown dropdown-hover nav-profile nav-link-separator-after d-flex align-items-center"
                  >
                    <app-nav-profile class="flex-grow-1"></app-nav-profile>
                  </li>
                } @else if (!sessionService.restoringSession) {
                  <div
                    class="nav-link-separator-after px-3 d-flex align-items-center"
                    [class.nav-link-separator-before]="
                      !communitySpacesDropdownDisplayed
                    "
                  >
                    <button
                      class="btn btn-primary d-flex align-items-center"
                      (click)="goToLoginPage()"
                    >
                      <ng-icon
                        class="me-2"
                        name="matAccountCircle"
                      ></ng-icon>

                      {{ 'Login' | translate }}
                    </button>
                  </div>
                }
              </ul>
            }

            <app-languages class="d-none d-md-block ps-3"></app-languages>

            <div
              class="d-flex d-md-none align-items-center mt-2 navigation__content--padding"
            >
              <span class="pe-2 ps-1 pt-2 nav-link">
                {{ 'UI.PoweredBy' | translate }}
              </span>

              <app-shared-icon
                name="logoBBV"
                width="50px"
                height="30px"
              ></app-shared-icon>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center">
        @if (communitySpacesDropdownDisplayed && mobileHeader) {
          <div class="d-flex align-items-center d-md-none pt-1 pb-2 px-2 lh-1">
            <app-community-space-dropdown />
          </div>
        }

        @if (sessionService.isOnListPage) {
          <button
            class="navbar-toggler navigation-toggler text-black py-1 px-3 font-size-xl"
            type="button"
            (click)="toggleSearch()"
          >
            <ng-icon name="matSearchOutline"></ng-icon>
          </button>
        }

        <button
          class="navbar-toggler navigation-toggler text-black py-1 px-2 font-size-xl"
          type="button"
          (click)="toggleNavs()"
        >
          <ng-icon name="matMenuOutline"></ng-icon>
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="global-filter flex-grow-1 d-md-none"
  [ngClass]="{ show: isSearchActivated }"
>
  <div class="global-filter__close">
    <button
      type="button"
      class="btn fw-bold m-0 p-0"
      (click)="closeFilters()"
    >
      <span aria-hidden="true">×</span>
    </button>
  </div>

  <div class="d-flex flex-column w-auto">
    <div class="global-filter__search">
      <form
        (submit)="onSearch()"
        action="#"
        class="global-filter__search-form"
      >
        <input
          type="text"
          name="query"
          class="form-control global-filter__search-input"
          placeholder="{{ 'Search' | translate }}"
          [attr.aria-label]="'Search' | translate"
          [(ngModel)]="searchText"
          (ngModelChange)="onSearchTextChange($event)"
        />
      </form>

      <div class="search-control">
        @if (searchText) {
          <ng-icon
            name="matCloseOutline"
            class="reset-search me-3"
            appDebounceClick
            (debounceClick)="onClearText()"
            focusable="false"
          ></ng-icon>
        }

        <ng-icon
          name="matSearchOutline"
          class="pointer-cursor"
          appDebounceClick
          (debounceClick)="onSearch(); closeFilters()"
        ></ng-icon>
      </div>
    </div>

    <div class="global-filter__applied d-flex align-items-center">
      <div class="flex-shrink-0">
        <span class="filter-applied-title">
          {{ 'UI.GlobalFilter.FilterApplied' | translate }}:</span
        >
      </div>

      <div class="flex-1">
        @if (selectedOrg) {
          <span
            [ngbTooltip]="selectedOrg?.name"
            class="global-filter__org-name ms-1 fw-bold"
            >{{ selectedOrg?.name }}</span
          >
        } @else {
          <span
            class="global-filter__org-name ms-1 fw-bold"
            translate
            >All Innovation Spaces</span
          >
        }
      </div>
    </div>
  </div>
</div>
